import {initialDataActionTypes} from "./actionTypes"

/**
 * @param {?string} token
 * @param {PrepareAppData} data
 */

export function setInitialData(data, token) {
    data.token = token;
    return {
        type: initialDataActionTypes.SET_INITIAL_DATA,
        payload: data
    }
}

export function setVerifyResponseData(data){
    return {
        type: initialDataActionTypes.SET_VERIFY_RESPONSE_DATA,
        payload: data
    }
}

export function setCensusEeAddress(address) {
    return {
        type: initialDataActionTypes.SET_CENSUS_EE_ADDRESS,
        payload: {eeCensusAddress: address}
    }
}

export function setEtContractTermsData(eTcontractTermsData) {
    return {
        type: initialDataActionTypes.SET_ET_CONTRACT_TERMS_DATA,
        payload: eTcontractTermsData
    }
}

export function setIsMember(isMember) {
    return {
        type: initialDataActionTypes.SET_IS_MEMBER,
        payload: {isMember: isMember}
    }
}

export function setEnrollmentDeclined(enrollmentDeclined) {
    return {
        type: initialDataActionTypes.SET_ENROLLMENT_DECLINED,
        payload: {enrollmentDeclined: enrollmentDeclined}
    }
}
